import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getUser, getError } from '../../reducers';
import LogIn from '../containers/LogIn';
import * as Constants from '../../constants';
import MainAdmin from '../admin/MainAdmin';
import { setUserById } from '../../actions/user/setUserById';
import { auth } from '../../config/Fire';
import LoadingPage from '../components/LoadingPage';
import MainClient from '../client/MainClient';
import MainEmployee from '../employee/MainEmployee';
import MainRegister from '../register/MainRegister';

const MainApp = (props) => {
    const[loading, setLoading] = useState(true)

    const authListener = () => {
        auth.onAuthStateChanged((user) => {
            if(user && user.uid) {
                setLoading(true)
                props.setUserById(user.uid)
            } else {
                setLoading(false)
            }
        });
    }

    useEffect(() => {
        authListener()
    }, [])

    const renderMainByUserType = userType => {
        switch (userType) {
            case Constants.USER_TYPES.ADMIN:
                return <MainAdmin />
            case Constants.USER_TYPES.EMPLOYEE:
                return <MainEmployee />
            case Constants.USER_TYPES.CLIENT:
                return <MainClient />
            case Constants.USER_TYPES.REGISTER:
                return <MainRegister />
        }
    }

    return (
        <div className="MainUser">
        { props.error.state ?
            <LogIn />
            :
            props.user && props.user.userType && (props.user.userType === Constants.USER_TYPES.ADMIN || props.user.userType === Constants.USER_TYPES.EMPLOYEE || props.user.userType === Constants.USER_TYPES.CLIENT || props.user.userType === Constants.USER_TYPES.REGISTER) ?
                renderMainByUserType(props.user.userType)
                :
                loading ?
                    <LoadingPage />
                    :
                    <LogIn />
        }
        </div>
    );
};

MainApp.propTypes = {
    user: PropTypes.object,
    error: PropTypes.object,
};

const mapDispatchToPropsActions = dispatch => ({
    setUserById: value => dispatch(setUserById(value)),
});

const mapStateToProps = state => ({ 
    user:  getUser(state),
    error: getError(state),
});

export default connect(mapStateToProps, mapDispatchToPropsActions)(MainApp);